// Typelizer digest e36a397adc86b8c7eeea07dc7c86d0d9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /digest/unsubscribe/:token */
  show: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/digest/unsubscribe/:token', params, options),
    method: 'get',
  }),

  /** POST /digest/unsubscribe/:token */
  create: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/digest/unsubscribe/:token', params, options),
    method: 'post',
  }),
}
